import client from './client';

const getResumeGate = () => client.get('/api/auto-apply-promo/resume-gate');

// Both writes answer with the refreshed user, so callers can replace the cached copy.
const dismissAutoApplyPromo = ({ optOut = false } = {}) =>
	client.post('/api/auto-apply-promo/dismiss', { opt_out: optOut });

const completeAutoApplyPromo = () => client.post('/api/auto-apply-promo/complete');

// Same pipeline as the onboarding upload, minus the free resume_upload quota.
const uploadAutoApplyPromoResume = (file, config = {}) => {
	const formData = new FormData();
	formData.append('file', file);
	return client.post('/api/auto-apply-promo/resume', formData, config);
};

export { getResumeGate, dismissAutoApplyPromo, completeAutoApplyPromo, uploadAutoApplyPromoResume };
